import React from "react";
import { Container } from "react-bootstrap";
import { ArticleSection, StyledButton } from "../components";
import { useScrollToTopAndNavigate } from "../hooks";
import { useTranslation } from "react-i18next";

import bg_03 from "./../images/Content/Backhaus-Häussler-28.jpg"
import bg_05 from "./../images/Content/haeussler-job-01.webp"

const PageNotFound: React.FunctionComponent = () => {
  const handleNavigation = useScrollToTopAndNavigate();
  const { t } = useTranslation(["pageNotFound", "commom"])

  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontWeight: 300,
    fontSize: "28px",
    lineHeight: "45px",
    color: "#342714",
    letterSpacing: ".05em"
  };

  return (
    <Container>
      <ArticleSection
        id={"section_start"}
        layout="article_right_bg"
        title={t("sections.notfound.title")}
        content={
          <div>
            <p style={contentStyle}>{t("sections.notfound.content")}</p>
            <StyledButton title={t("sections.notfound.button")} onClick={() => {handleNavigation("/#section_start")}} />
          </div>
        }
        imageUrl={bg_03}
        backgroundColor="#F4EBE5"
      />
      <ArticleSection
        layout="article_left"
        title={t("common:sections.jobs.title")}
        content={
          <div>
            <p style={contentStyle}>{t("common:sections.jobs.content")}</p>
            <StyledButton title={t("common:sections.jobs.button")} onClick={() => {handleNavigation("https://bhmm.de/employees#job-offers", { openInNewTab: true })}} />
          </div>
        }
        imageUrl={bg_05}
        backgroundColor="#DDEBEA"
      />
    </Container>
  );
}

export default PageNotFound;
